import { motion } from 'framer-motion';
import { useState } from 'react';
import { X } from 'lucide-react';

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    '/projects/WhatsApp Image 2026-05-26 at 11.53.10.jpeg',
    '/projects/WhatsApp Image 2026-05-26 at 11.53.10 (1).jpeg',
    '/projects/WhatsApp Image 2026-05-26 at 11.53.11.jpeg',
    '/projects/WhatsApp Image 2026-05-26 at 11.53.11 (1).jpeg',
    '/projects/WhatsApp Image 2026-05-26 at 11.53.11 (2).jpeg',
  ];

  return (
    <>
      <section
        id="gallery"
        className="py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-24"
        data-testid="gallery-section"
      >
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <p className="text-xs uppercase tracking-[0.3em] font-medium text-[#2C6E63] mb-4">
              Gallery
            </p>
            <h2 className="font-heading text-4xl sm:text-5xl font-light tracking-tight text-[#2D3436] mb-6">
              Our Latest Work
            </h2>
            <motion.div 
              initial={{ width: 0 }}
              whileInView={{ width: 64 }}
              transition={{ duration: 1, delay: 0.3 }}
              viewport={{ once: true }}
              className="h-px bg-[#D4C4A8] mx-auto"
            ></motion.div>
          </motion.div>

          {/* Gallery Grid - Masonry style */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {galleryImages.map((img, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: index * 0.1, ease: [0.215, 0.61, 0.355, 1] }}
                viewport={{ once: true, margin: "-50px" }}
                className={`relative overflow-hidden cursor-pointer group ${
                  index === 0 ? 'sm:col-span-2 lg:col-span-2 lg:row-span-2 aspect-[2/1.5]' : 'aspect-square'
                }`}
                onClick={() => setSelectedImage(img)}
                data-testid={`gallery-image-${index}`}
              >
                <motion.img
                  src={img}
                  alt={`Project ${index + 1}`}
                  className="w-full h-full object-cover"
                  whileHover={{ scale: 1.08 }}
                  transition={{ duration: 0.8, ease: [0.215, 0.61, 0.355, 1] }}
                />
                
                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-[#2D3436]/0 group-hover:bg-[#2D3436]/30 transition-all duration-500 flex items-center justify-center">
                  <motion.div 
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileHover={{ opacity: 1, scale: 1 }}
                    className="w-12 h-12 border-2 border-white opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center"
                  >
                    <span className="text-white text-2xl font-light">+</span>
                  </motion.div>
                </div>

                {/* Corner Accents */}
                <div className="absolute top-4 left-4 w-6 h-6 border-t border-l border-white/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute bottom-4 right-4 w-6 h-6 border-b border-r border-white/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {selectedImage && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] bg-[#2D3436]/95 flex items-center justify-center p-6"
          onClick={() => setSelectedImage(null)}
          data-testid="gallery-lightbox"
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-6 right-6 text-white hover:text-[#D4C4A8] transition-colors z-10"
            data-testid="gallery-close"
          >
            <X size={32} strokeWidth={1.5} />
          </button>
          <motion.img
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.4 }}
            src={selectedImage}
            alt="Gallery"
            className="max-w-[90vw] max-h-[90vh] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </motion.div>
      )}
    </>
  );
};

export default GallerySection;
